import { useAccount, useMsal } from '@azure/msal-react';
import './App.css';
import Layout from './components/layout/Layout';
import Routing from './components/routes/Routing';
import { translationService } from 'e.sic-platform.webclient/src/services/translation/TranslationService';
import LoadingSpinner from 'e.sic-platform.webclient/src/components/loading-spinner/LoadingSpinner';
import { observer } from 'mobx-react-lite';
import useUrlQueryParams from 'e.sic-platform.webclient/src/services/url/UrlQueryService';
import { useEffect } from 'react';
import { appSessionStorage } from 'e.sic-platform.webclient/src/services/storage/SessionStorageService';
import { authentication } from 'e.sic-platform.webclient/src/services/authentication/Authentication';
import { VIEWER_TOKEN_KEY } from 'e.sic-platform.webclient/src/services/authentication/AuthService';
import { areLoading } from 'e.sic-platform.webclient/src/services/storage/StorageModel';
import { lastAccessedOrganizationService } from 'e.sic-platform.webclient/src/services/organization/LastAccessedOrganizationStorage';
import { organizationSubscriptionService } from 'e.sic-platform.webclient/src/services/organization/OrganizationSubscription';
import { permissionsService } from 'e.sic-platform.webclient/src/services/authorization/UserPermissionsService';
import { currentUserService } from 'e.sic-platform.webclient/src/services/user/CurrentUserStorage';
import { featureFlagsStorage } from 'e.sic-platform.webclient/src/services/feature-flags/FeatureFlagsStorage';
import { activityPricesStorage } from 'e.sic-platform.webclient/src/services/shop/ActivityPricesStorage';
import { creditBalanceStorage } from 'e.sic-platform.webclient/src/services/shop/CreditBalanceStorage';
import { shopHistoryStorage } from 'e.sic-platform.webclient/src/services/shop/ShopHistoryStorage';
import { mainCodeColorStorage } from 'e.sic-platform.webclient/src/services/mc-colors/MainCodeColorStorage';

export default observer(function App() {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { authToken } = useUrlQueryParams();

  useEffect(() => {
    if (authentication.anonymous) {
      if (accounts.length > 0) authentication.setAnonymous(false);
    } else {
      const viewerAuthToken = authToken || appSessionStorage.getStorageItem(VIEWER_TOKEN_KEY);
      authentication.loginAndObtainToken(instance, account, viewerAuthToken, inProgress);
    }
  }, [account, authToken, inProgress, instance, authentication.anonymous]);

  if (
    areLoading([
      lastAccessedOrganizationService,
      organizationSubscriptionService,
      permissionsService,
      currentUserService,
      featureFlagsStorage,
      activityPricesStorage,
      creditBalanceStorage,
      shopHistoryStorage,
      mainCodeColorStorage
    ])
  ) {
    return <LoadingSpinner fullPage />;
  }

  if (!translationService.translationsLoaded) {
    return <LoadingSpinner fullPage />;
  }

  return (
    <Layout>
      <Routing />
    </Layout>
  );
})
